export default "__VITE_ASSET__aa2ad36c__"